var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownArrowLarge = function SvgDownArrowLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 4 8 8 8-8",
    stroke: "#fff"
  })));
};
export default SvgDownArrowLarge;